import "./style.css"

<lifecycle
  onMount() {
    var path = window.location.pathname;
    var links = document.querySelectorAll('#nav-ul a');
    links.forEach(function(link) {
      var href = link.getAttribute('href');
      if (href === '/' ? path === '/' : path.startsWith(href)) {
        link.classList.add('active-link');
      }
    });
  }
/>

<header id="home">
  <div class="header-inner">
    <div class="header-brand">
      <h1>Robert Truese</h1>
      <p class="header-subtitle">Full Stack Developer</p>
    </div>
    <input type="checkbox" id="nav-toggle" class="nav-toggle" aria-hidden="true" />
    <label for="nav-toggle" class="nav-toggle-label" aria-label="Toggle navigation">
      <span/>
      <span/>
      <span/>
    </label>
    <nav aria-label="Main navigation">
      <ul id="nav-ul">
        <li><a href="/">Home</a></li>
        <li><a href="/about">About</a></li>
        <li><a href="/projects">Projects</a></li>
        <li><a href="/contact">Contact</a></li>
      </ul>
    </nav>
  </div>
</header>
